module.exports = __webpack_public_path__ + "assets/img/mecha-f808c537.png";